/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsCreateWorkScheduleModelRequest,
  FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsUpdateWorkScheduleModelRequest,
  FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelChangePreviewDto,
  FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelDto,
  FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelListDto,
  GetApiV1WorkScheduleModelsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getWorkScheduleModels = () => {
/**
 * @summary Get all work schedule models
 */
const getApiV1WorkScheduleModels = (
    params?: GetApiV1WorkScheduleModelsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelListDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelListDto[]>(
      {url: `/api/v1/work-schedule-models`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new work schedule model
 */
const postApiV1WorkScheduleModels = (
    facilityFlowCoreModulesPlanningDtosWorkScheduleModelsCreateWorkScheduleModelRequest: FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsCreateWorkScheduleModelRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelDto>(
      {url: `/api/v1/work-schedule-models`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosWorkScheduleModelsCreateWorkScheduleModelRequest
    },
      options);
    }
  /**
 * @summary Get work schedule model by ID
 */
const getApiV1WorkScheduleModelsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelDto>(
      {url: `/api/v1/work-schedule-models/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing work schedule model
 */
const putApiV1WorkScheduleModelsId = (
    id: string,
    facilityFlowCoreModulesPlanningDtosWorkScheduleModelsUpdateWorkScheduleModelRequest: FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsUpdateWorkScheduleModelRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelDto>(
      {url: `/api/v1/work-schedule-models/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosWorkScheduleModelsUpdateWorkScheduleModelRequest
    },
      options);
    }
  /**
 * @summary Delete a work schedule model
 */
const deleteApiV1WorkScheduleModelsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/work-schedule-models/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Preview what an update would do to the planning (affected work days, target change up
to today) without saving anything — used before applying a change from a past date.
 */
const postApiV1WorkScheduleModelsIdPreview = (
    id: string,
    facilityFlowCoreModulesPlanningDtosWorkScheduleModelsUpdateWorkScheduleModelRequest: FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsUpdateWorkScheduleModelRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelChangePreviewDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsWorkScheduleModelChangePreviewDto>(
      {url: `/api/v1/work-schedule-models/${id}/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosWorkScheduleModelsUpdateWorkScheduleModelRequest
    },
      options);
    }
  return {getApiV1WorkScheduleModels,postApiV1WorkScheduleModels,getApiV1WorkScheduleModelsId,putApiV1WorkScheduleModelsId,deleteApiV1WorkScheduleModelsId,postApiV1WorkScheduleModelsIdPreview}};
export type GetApiV1WorkScheduleModelsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getWorkScheduleModels>['getApiV1WorkScheduleModels']>>>
export type PostApiV1WorkScheduleModelsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getWorkScheduleModels>['postApiV1WorkScheduleModels']>>>
export type GetApiV1WorkScheduleModelsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getWorkScheduleModels>['getApiV1WorkScheduleModelsId']>>>
export type PutApiV1WorkScheduleModelsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getWorkScheduleModels>['putApiV1WorkScheduleModelsId']>>>
export type DeleteApiV1WorkScheduleModelsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getWorkScheduleModels>['deleteApiV1WorkScheduleModelsId']>>>
export type PostApiV1WorkScheduleModelsIdPreviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getWorkScheduleModels>['postApiV1WorkScheduleModelsIdPreview']>>>
